export default {
    packages_list_data(state) {
        return state.resources.package_categories.map((c) => {
            return {
                ...c,
                items: state.resources.packages.filter(p => p.category_id === c.id)
            }
        });

    },
}
